import axios from 'axios';
// eslint-disable-next-line import/named
import { FILE_MAX_SIZE_MB } from '@/utils/constants';
import { applyBearerOrCookie } from './authStrategy';
import store from './store';

const driveRequest = (config, explicitToken) => {
  const resolvedAccessTokenForAuth = explicitToken === undefined ? store.getToken() : explicitToken;
  return axios(applyBearerOrCookie(config, resolvedAccessTokenForAuth));
};

const RULE = '/rule/';

const DIRECTORY = '/directory';
const DIR_READ = '/directory/read';
const DIR_READ_CONTRACT = '/directory/readContract';
const DIR_READ_ACCESS_PERMISSION = '/directory/readAccessPermission';
const DIR_READ_USERS_ACCESS_PERMISSION_BY_FINANCIAL_GROUP = '/directory/readUsersWithAccessPermissionByFinancialGroup';
const DRIVE_ALREADY_INITIALIZED = '/directory/driveAlreadyInitialized';
const DIR_CREATE = '/directory/create-dir';
const ACCESS_PERMISSION = '/access_permission';

export const FILE_UPLOAD = '/file/upload';
const FILE_DOWNLOAD = '/file/download/';
const FILE_DOWNLOAD_ZIP = '/file/downloadZip';
const FILE_DELETE = '/file/delete';
const FILE_RENAME = '/file/rename';

const ALL_TEMPLATES = '/template/active';
const ALL_CREDENTIALS = '/credential/active';
const ALL_RULE_DRIVE_GROUPS_BY_USER_ROLE = '/rule_drive_group/user_role/';
const INIT_DRIVE = '/configure/init';
const NOTIFICATION_CONFIG = '/notification_config/';
const TOKEN_FULL = '/token/full';
const MANUALLY_NOTIFICATION_CONFIG = '/notification_config/createManuallyNotification';
const ALL_NOTIFICATION_CONFIG = '/notification_config/findAllByPath';

const CURRENT_USER_URI = '/user/current';

export const VALIDATE_SIZE_MESSAGE = `Não é permitido enviar arquivos que tenham mais de\
  ${FILE_MAX_SIZE_MB}mb. Por favor, revise os arquivos selecionados\
  e remova aqueles não atendem a regra.`;

export const {
  VUE_APP_DRIVE_SERVICE_URL,
  VUE_APP_AUTH_SERVICE_URL,
// eslint-disable-next-line no-undef
} = process.env;

const VUE_APP_SECURITY_SERVICE_URL = `${VUE_APP_DRIVE_SERVICE_URL}`.replace('/api/drive', '/api/security');

export const MESSAGE_NOT_AUTORIZED = 'Você não esta autorizado a realizar esta operação';
export const MESSAGE_FILE_EXISTING = 'Já existe arquivo com o mesmo nome';
export const MESSAGE_FOLDER_EXISTING = 'Já existe um diretório com este nome';
export const MESSAGE_ERRO = 'Houve um erro ao realizar esta operação';
export const EMPTY_DIRECTORY = 'O diretório que você esta tentando excluir não esta vazio';
export const FAILED_LOAD_FILES = 'Falha ao carregar os arquivos';
export const MESSAGE_MAX_SIZE_DOWNLOAD = 'Valor máximo para download de arquivos: 120 mb. Acima desse valor, realizar o download unitário de arquivos.';
export const MEDIA_TYPE_DIRECTORY = 'diretório';
export const MEDIA_TYPE_ALL_DIALOG = 'dialog';
export const MEDIA_TYPE_FILE = 'arquivo';


const getRule = (id) => {
  const url = `${RULE}${id}`;

  return driveRequest({
    url,
    method: 'get',
    params: {
      driveCredentialCode: store.getDriveCredentialCode(),
    },
  });
};

const getDirectory = (path) => {
  const url = `${VUE_APP_DRIVE_SERVICE_URL}${DIR_READ}/${encodeURI(path)}`;

  return driveRequest({
    url,
    method: 'get',
    params: {
      driveCredentialCode: store.getDriveCredentialCode(),
    },
  });
};

const getImplantation = (path) => {
  const url = `${VUE_APP_DRIVE_SERVICE_URL}${DIR_READ_CONTRACT}/${encodeURI(path)}`;

  return driveRequest({
    url,
    method: 'get',
    params: {
      driveCredentialCode: store.getDriveCredentialCode(),
    },
  });
};

const getDirectoryAccessPermission = (path, token) => {
  const url = `${VUE_APP_DRIVE_SERVICE_URL}${DIR_READ_ACCESS_PERMISSION}/${encodeURI(path)}`;
  return driveRequest({
    url,
    method: 'get',
    params: {
      driveCredentialCode: store.getDriveCredentialCode(),
    },
  }, token);
};

const createDirectory = (path, name) => {
  const url = `${VUE_APP_DRIVE_SERVICE_URL}${DIR_CREATE}`;

  return driveRequest({
    url,
    method: 'post',
    data: {
      name: encodeURI(name),
      path: encodeURI(path),
    },
    params: {
      driveCredentialCode: store.getDriveCredentialCode(),
    },
  });
};

const deleteDirectory = (path) => {
  const url = `${VUE_APP_DRIVE_SERVICE_URL}${DIRECTORY}`;

  return driveRequest({
    url,
    method: 'delete',
    data: {
      path: encodeURI(path),
    },
    params: {
      driveCredentialCode: store.getDriveCredentialCode(),
    },
  });
};

const uploadFile = (path, name, file, fileData) => {
  const url = `${VUE_APP_DRIVE_SERVICE_URL}${FILE_UPLOAD}?path=${encodeURIComponent(path)}`;
  const formData = new FormData();

  formData.append('file', fileData, name);

  return driveRequest({
    url,
    method: 'post',
    data: formData,
    params: {
      driveCredentialCode: store.getDriveCredentialCode(),
    },
  });
};

const downloadFile = (path) => {
  const url = `${VUE_APP_DRIVE_SERVICE_URL}${FILE_DOWNLOAD}${encodeURI(path)}`;

  return driveRequest({
    url,
    method: 'get',
    responseType: 'arraybuffer',
    params: {
      driveCredentialCode: store.getDriveCredentialCode(),
    },
  });
};


const downloadFileZip = (path, files) => {
  const url = `${VUE_APP_DRIVE_SERVICE_URL}${FILE_DOWNLOAD_ZIP}`;

  return driveRequest({
    url,
    method: 'post',
    responseType: 'arraybuffer',
    data: {
      path: encodeURI(path),
      driveCredentialCode: store.getDriveCredentialCode(),
      files,
    },
  });
};

const deleteFile = (path) => {
  const url = `${VUE_APP_DRIVE_SERVICE_URL}${FILE_DELETE}`;

  return driveRequest({
    url,
    method: 'delete',
    data: {
      path: encodeURI(path),
    },
    params: {
      driveCredentialCode: store.getDriveCredentialCode(),
    },
  });
};

const renameFile = (path, newName, oldName) => {
  const url = `${VUE_APP_DRIVE_SERVICE_URL}${FILE_RENAME}`;

  return driveRequest({
    url,
    method: 'put',
    data: {
      newName: encodeURI(newName),
      oldName: encodeURI(oldName),
      path: encodeURI(path),
    },
    params: {
      driveCredentialCode: store.getDriveCredentialCode(),
    },
  });
};

const removeAccents = (value) => {
  const diacritics = [
    { char: 'A', base: /[\300-\306]/g },
    { char: 'a', base: /[\340-\346]/g },
    { char: 'E', base: /[\310-\313]/g },
    { char: 'e', base: /[\350-\353]/g },
    { char: 'I', base: /[\314-\317]/g },
    { char: 'i', base: /[\354-\357]/g },
    { char: 'O', base: /[\322-\330]/g },
    { char: 'o', base: /[\362-\370]/g },
    { char: 'U', base: /[\331-\334]/g },
    { char: 'u', base: /[\371-\374]/g },
    { char: 'N', base: /[\321]/g },
    { char: 'n', base: /[\361]/g },
    { char: 'C', base: /[\307]/g },
    { char: 'c', base: /[\347]/g },
  ];

  let retVal = '';
  diacritics.forEach((letter) => {
    retVal = value.replace(letter.base, letter.char);
  });

  return retVal;
};

const getTemplates = () => {
  const url = `${VUE_APP_DRIVE_SERVICE_URL}${ALL_TEMPLATES}`;

  return driveRequest({
    url,
    method: 'get',
    params: {
      driveCredentialCode: store.getDriveCredentialCode(),
    },
  });
};

const getCredentials = () => {
  const url = `${VUE_APP_DRIVE_SERVICE_URL}${ALL_CREDENTIALS}`;

  return driveRequest({
    url,
    method: 'get',
    params: {
      driveCredentialCode: store.getDriveCredentialCode(),
    },
  });
};

const getRuleDriveGroups = (userRole) => {
  const url = `${VUE_APP_DRIVE_SERVICE_URL}${ALL_RULE_DRIVE_GROUPS_BY_USER_ROLE}${userRole}`;

  return driveRequest({
    url,
    method: 'get',
    params: {
      driveCredentialCode: store.getDriveCredentialCode(),
    },
  });
};

const initDrive = (init) => {
  const url = `${VUE_APP_DRIVE_SERVICE_URL}${INIT_DRIVE}`;

  return driveRequest({
    url,
    method: 'post',
    data: init,
    params: {
      driveCredentialCode: store.getDriveCredentialCode(),
    },
  });
};

const saveAccessPermission = (accessPermission) => {
  const url = `${VUE_APP_DRIVE_SERVICE_URL}${ACCESS_PERMISSION}`;

  return driveRequest({
    url,
    method: 'post',
    data: accessPermission,
  });
};

const editAccessPermission = (accessPermission, id) => {
  const url = `${VUE_APP_DRIVE_SERVICE_URL}${ACCESS_PERMISSION}/${id}`;

  return driveRequest({
    url,
    method: 'put',
    data: accessPermission,
  });
};

const deleteAccessPermission = (id) => {
  const url = `${VUE_APP_DRIVE_SERVICE_URL}${ACCESS_PERMISSION}/${id}`;

  return driveRequest({
    url,
    method: 'delete',
  });
};

const listAccessPermissionBy = (accessPermission) => {
  const url = `${VUE_APP_DRIVE_SERVICE_URL}${ACCESS_PERMISSION}/findBy`;

  return driveRequest({
    url,
    method: 'post',
    data: accessPermission,
  });
};

const getCurrentUser = (token) => {
  const url = `${VUE_APP_SECURITY_SERVICE_URL}${CURRENT_USER_URI}`;
  return driveRequest({
    url,
    method: 'get',
  }, token).then((response) => response.data).catch(() => {});
};

const verifyIfDriveHasAlreadyInitialized = () => {
  const url = `${VUE_APP_DRIVE_SERVICE_URL}${DRIVE_ALREADY_INITIALIZED}`;

  return driveRequest({
    url,
    method: 'get',
  });
};

const pathHasAccessPermissionConfigured = (path) => {
  const url = `${VUE_APP_DRIVE_SERVICE_URL}${ACCESS_PERMISSION}/pathHasAccessPermissionConfigured/${encodeURI(path)}`;

  return driveRequest({
    url,
    method: 'get',
  });
};

const saveNotificationConfig = (notificationConfig) => {
  const url = `${VUE_APP_DRIVE_SERVICE_URL}${NOTIFICATION_CONFIG}`;

  return driveRequest({
    url,
    method: 'post',
    data: notificationConfig,
  });
};

const getJWTToken = () => {
  const url = `${VUE_APP_AUTH_SERVICE_URL}${TOKEN_FULL}`;

  return driveRequest({
    url,
    method: 'get',
  });
};

const createManuallyNotification = (notificationConfig) => {
  const url = `${VUE_APP_DRIVE_SERVICE_URL}${MANUALLY_NOTIFICATION_CONFIG}`;

  return driveRequest({
    url,
    method: 'post',
    data: notificationConfig,
  });
};

const updateNotificationConfig = (notificationConfig, id) => {
  const url = `${VUE_APP_DRIVE_SERVICE_URL}${NOTIFICATION_CONFIG}${id}`;

  return driveRequest({
    url,
    method: 'put',
    data: notificationConfig,
  });
};

const findAllNotificationConfigs = (pathFileDir) => {
  const url = `${VUE_APP_DRIVE_SERVICE_URL}${ALL_NOTIFICATION_CONFIG}`;

  return driveRequest({
    url,
    method: 'get',
    params: {
      pathFileDir,
    },
  });
};

const findNotificationConfigById = (id) => {
  const url = `${VUE_APP_DRIVE_SERVICE_URL}${NOTIFICATION_CONFIG}${id}`;

  return driveRequest({
    url,
    method: 'get',
  });
};

const deleteNotificationConfig = (id) => {
  const url = `${VUE_APP_DRIVE_SERVICE_URL}${NOTIFICATION_CONFIG}${id}`;

  return driveRequest({
    url,
    method: 'delete',
  });
};

const getAllUsersWithAccessPermissionByFinancialGroup = (path, token) => {
  const url = `${VUE_APP_DRIVE_SERVICE_URL}${DIR_READ_USERS_ACCESS_PERMISSION_BY_FINANCIAL_GROUP}/${encodeURI(path)}`;
  return driveRequest({
    url,
    method: 'get',
    params: {
      driveCredentialCode: store.getDriveCredentialCode(),
    },
  }, token);
};

export {
  getImplantation,
  getRule,
  getDirectory,
  getDirectoryAccessPermission,
  createDirectory,
  deleteDirectory,
  uploadFile,
  downloadFile,
  downloadFileZip,
  deleteFile,
  renameFile,
  removeAccents,
  getTemplates,
  getCredentials,
  getRuleDriveGroups,
  initDrive,
  saveAccessPermission,
  editAccessPermission,
  deleteAccessPermission,
  listAccessPermissionBy,
  getCurrentUser,
  verifyIfDriveHasAlreadyInitialized,
  pathHasAccessPermissionConfigured,
  saveNotificationConfig,
  updateNotificationConfig,
  deleteNotificationConfig,
  findNotificationConfigById,
  findAllNotificationConfigs,
  getAllUsersWithAccessPermissionByFinancialGroup,
  createManuallyNotification,
  getJWTToken,
};
